import { Component, h } from '@stencil/core';
import URLS from './urls';

declare global {
  interface Window {
      dataLayer: any;
  }
}

@Component({
  tag: 'app-root',
  shadow: false,
  scoped: false
})

export class AppRoot {
  render() {
    return (
      <div>
        <app-header />

        <main>
          <stencil-router>
            <stencil-route-switch scrollTopOffset={1}>
              <stencil-route url='/' component='app-home' exact={true} />
              {/* PRODUCT */}
              <stencil-route url={URLS.AppProduct} component='app-product' exact={true} />
              <stencil-route url={URLS.AppProductDesignPWA} component='app-product-design-pwa' exact={true} />
              <stencil-route url={URLS.AppProductMagento2core} component='app-product-magento-2-core' exact={true} />
              <stencil-route url={URLS.AppProductAutomation} component='app-product-automation' exact={true} />
              <stencil-route url={URLS.AppProductProcess} component='app-product-process' exact={true} />
              <stencil-route url={URLS.AppProductHosting} component='app-product-hosting' exact={true} />
              <stencil-route url={URLS.AppProductGdprDataGovernanace} component='app-product-gdpr-data-governance' exact={true} />
              <stencil-route url={URLS.AppProductIntegrations} component='app-product-integrations' exact={true} />
              <stencil-route url={URLS.AppErpIntegrations} component='app-erp-integrations' exact={true} />
              <stencil-route url={URLS.AppMarketingIntegration} component='app-marketing-integration' exact={true} />
              <stencil-route url={URLS.AppMarketplaceIntegrations} component='app-marketplace-integrations' exact={true} />
              <stencil-route url={URLS.AppHostingArhitecture} component='app-hosting-arhitecture' exact={true} />
              <stencil-route url={URLS.AppSecurityFirst} component='app-security-first' exact={true} />
              <stencil-route url={URLS.AppWeMonitorEverything} component='app-we-monitor-everything' exact={true} />
              {/* PRODUCT - END*/}
              <stencil-route url={URLS.AppContactPage} component='app-contact-page' exact={true} />
              <stencil-route url={URLS.AppPriceSlider} component='app-price-slider' exact={true} />
              <stencil-route url={URLS.AppDataProtectionAndPrivacy} component='app-data-protection-and-privacy' exact={true} />
              {/* CAREERS */}
              <stencil-route url={URLS.AppCareers} component='app-careers' exact={true} />
              <stencil-route url={URLS.AppMarketingSpecialist} component='app-marketing-specialist' exact={true} />
              <stencil-route url={URLS.AppSalesReprezentative} component='app-sales-representative' exact={true} />
              <stencil-route url={URLS.AppCustomerSupportSpecialist} component='app-customer-support-specialist' exact={true} />
              <stencil-route url={URLS.AppCustomerSupportSpecialistPL} component='app-customer-support-specialist-pl' exact={true} />
              <stencil-route url={URLS.AppSeniorReactDeveloper} component='app-senior-react-developer' exact={true} />
              <stencil-route url={URLS.AppMagento2Develeper} component='app-magento2-developer' exact={true} />
              <stencil-route url={URLS.AppQaSpecialist} component='app-qa-specialist' exact={true} />
              <stencil-route url={URLS.AppWebDesigner} component='app-web-designer' exact={true} />
              {/* CAREERS - END */}
              {/* SWITCHING */}
              <stencil-route url={URLS.AppSwitchingToZento} component='app-switching-to-zento' exact={true} />
              <stencil-route url={URLS.AppReasonsForSwitching} component='app-reasons-for-switching' exact={true} />
              <stencil-route url={URLS.AppProcessForSwitching} component='app-process-for-switching' exact={true} />
              {/* SWITCHING - END*/}
              {/* PARTNER */}
              <stencil-route url={URLS.AppPartner} component='app-partner' exact={true} />
              <stencil-route url={URLS.AppFindPartner} component='app-partner-find' exact={true} />
              <stencil-route url={URLS.AppBecomePartner} component='app-partner-become' exact={true} />
              <stencil-route url={URLS.AppAffiliate} component='app-partner-affiliate' exact={true} />
              <stencil-route url={URLS.AppZentoCertifiedBusinessPartnerFaq} component='app-partner-faq-business' exact={true} />
              <stencil-route url={URLS.AppZentoCertifiedAffiliateFaq} component='app-partner-faq-affiliate' exact={true} />
              {/* PARTNER - END*/}
              {/* ABOUT */}
              <stencil-route url={URLS.AppAbout} component='app-about' exact={true} />
              <stencil-route url={URLS.AppLeadershipTeam} component='app-leadership-team' exact={true} />
              {/* ABOUT - END*/}
              <stencil-route url={URLS.AppPreContractualTerms} component='app-pre-contractual-terms' exact={true} />
              { /* WIKI */}
              {/* <stencil-route url={URLS.AppWiki} component='app-wiki' exact={true} />
              <stencil-route url={URLS.AppWikiOverviewWhyzento} component='app-wiki-overview-whyzento' exact={true} />
              <stencil-route url={URLS.AppWikiOverviewTco} component='app-wiki-overview-tco' exact={true} />
              <stencil-route url={URLS.AppWikiOverviewPwa} component='app-wiki-overview-pwa' exact={true} />
              <stencil-route url={URLS.AppWikiDesignVision} component='app-wiki-design-vision' exact={true} />
              <stencil-route url={URLS.AppWikiDesignGeneralDesignAndUx} component='app-wiki-design-general' exact={true} />
              <stencil-route url={URLS.AppWikiHostingWhatiscloudhosting} component='app-wiki-hosting-whatiscloudhosting' exact={true} />
              <stencil-route url={URLS.AppWikiHostingArchitecture} component='app-wiki-hosting-architecture' exact={true} />
              <stencil-route url={URLS.AppWikiHostingPwalambda} component='app-wiki-hosting-pwalambda' exact={true} />
              <stencil-route url={URLS.AppWikiHostingM2kubernetes} component='app-wiki-hosting-m2kubernetes' exact={true} />
              <stencil-route url={URLS.AppWikiHostingStorageDatabase} component='app-wiki-hosting-storagedatabase' exact={true} />
              <stencil-route url={URLS.AppWikiHostingSecurity} component='app-wiki-hosting-security' exact={true} /> */}
              { /* WIKI - END*/}
              { /* BLOG */}
              <stencil-route url={URLS.AppBlog} component='app-blog' exact={true} />
              <stencil-route url={URLS.AppBlogArticle} component='app-blog-article' exact={true} />
              <stencil-route url={URLS.AppBlog+'/:article'} component='app-blog-article' exact={false} />
              { /* BLOG - END*/}
              { /* LP*/}
              <stencil-route url={URLS.AppLps} component='app-lps' exact={true} />
              <stencil-route url={URLS.AppLPM1M2} component='app-lp-m1m2' exact={true} />
              { /* LP - END*/}
              <stencil-route url={URLS.AppAwsmkpSubscribe} component='app-awsmkp-subscribe' />
              <stencil-route component='app-page-not-found' />
            </stencil-route-switch>
          </stencil-router>
        </main>

        <app-footer />
        <app-gdpr />
      </div>
    );
  }
}
